import script from "./PagingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PagingBar.vue?vue&type=script&setup=true&lang=ts"

import "./PagingBar.vue?vue&type=style&index=0&id=01cd4742&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01cd4742"]])

export default __exports__